const Testimonials = ({}) => {
    return (
        <div className="d-flex justify-content-center">
           <p>[][][][][]</p>
        </div>
        )
}

export default Testimonials;